import $ from "jquery";
import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

$(function() {

    gsap.registerPlugin(ScrollTrigger);

    //nav

    const nav_ani = gsap.timeline({ paused: true })
        .to('.nav_li', { duration: .4, stagger: -.05, x: -100, opacity: 0, ease: 'quart.in' })
        .to('.nav', { duration: .4, opacity: 0, display: 'none' });
    const hamburger_link = $('.hamburger_link');
    let _this;
    let _scrollTop;


    hamburger_link.click(function(e) {
        e.preventDefault();
        _this = $(this);
        if (hamburger_link.hasClass('active')) {
            nav_ani.play();
            _this.removeClass('active');
        } else {
            nav_ani.reverse();
            _this.addClass('active');
        }
    });

    $('.nav_li').focusin(function() {
        $(this).addClass('show');
    });
    $('.nav_li').focusout(function() {
        $(this).removeClass('show');
    });

    if ($(window).width() > 480) {
        hamburger_link.addClass('active')
        $(window).scroll(function() {
            _scrollTop = $(this).scrollTop();
            if (_scrollTop > 100) {
                nav_ani.play();
                hamburger_link.removeClass('active');
            } else {
                nav_ani.reverse();
                hamburger_link.addClass('active');
            }
        });

    } else {
        nav_ani.seek('-=0', false);
        nav_ani.play();

        //開闔 --------------------------------------------
        const nav_link = $('.nav_link[href*="#"]');
        const subnav_box = $('.subnav_box');

        nav_link.attr('o', 1);
        subnav_box.slideUp(0);

        nav_link.click(function(e) {
            e.preventDefault();
            var _o = $(this).attr('o');
            if (_o == 1) {
                $(this).siblings(subnav_box).slideDown();
                $(this).attr('o', 0);
            } else {
                $(this).siblings(subnav_box).slideUp();
                $(this).attr('o', 1);
            }
        });
    }

    // TweenMax.set(nav, {
    //     opacity: 0,
    //     display: 'none'
    // })
    // hamburger_link.click(function() {
    //     if (_h) {
    //         hamburger.addClass('active');
    //         TweenMax.to(nav, .2, {
    //             opacity: 1,
    //             display: 'block',
    //             ease: Power2.easeOut
    //         });
    //     } else {
    //         hamburger.removeClass('active');
    //         TweenMax.to(nav, .2, {
    //             opacity: 0,
    //             display: 'none',
    //             ease: Quart.easeOut
    //         });
    //     }
    //     _h = !_h;
    // });

});